'use client';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

export function HeaderShell({ children, className }: { children: ReactNode; className?: string }) {
  const pathname = usePathname();
  const isHomepage = pathname === ROUTES.HOME();

  return (
    <header
      className={cn(
        'flex flex-col border-b ea-header',
        isHomepage && 'absolute left-0 top-0 z-50 w-full border-none bg-transparent',
        className,
      )}
    >
      {children}
    </header>
  );
}
